import { render, staticRenderFns } from "./RolePrices.vue?vue&type=template&id=7908ad52&"
import script from "./RolePrices.vue?vue&type=script&lang=js&"
export * from "./RolePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports